module.exports = __webpack_public_path__ + "img/isotipo.7f39868f.png";